import "unpoly/unpoly-bootstrap5.js"
import "unpoly/unpoly-bootstrap5.css"

import Helpers from "./helpers"

const start = ({ up, modalSelector }) => {
  up.compiler(modalSelector, async (modalHolder) => {
    const modalElement = up.fragment.get(modalHolder, ".modal")

    const modalContent = up.fragment.get(modalHolder, ".modal-content")
    if (!modalContent || !modalContent.hasChildNodes()) return

    const bootstrapModal = $(modalElement)

    const modalIsHidden = new Promise((resolve, reject) => {
      Helpers.addOneshotEventListener(modalHolder, "shown.bs.hidden", resolve)
    })

    const modalIsShowing = new Promise((resolve, reject) => {
      Helpers.addOneshotEventListener(modalHolder, "shown.bs.modal", resolve)
    })

    /* always trigger destruction if modal closes unexpectedly */
    const removeCatchallDestroyListener = Helpers.addOneshotEventListener(
      modalElement,
      "hidden.bs.modal",
      () => up.destroy(modalElement)
    )

    const hideAndDestroyModal = () => {
      removeCatchallDestroyListener()

      bootstrapModal.modal("hide")

      up.destroy(modalElement)

      up.destroy(".modal-backdrop")
    }

    const showModal = () => {
      bootstrapModal.modal("show")

      return modalIsShowing
    }

    up.destructor(modalElement, hideAndDestroyModal)

    await showModal()

    return hideAndDestroyModal
  })
}

export default { start }
